var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 5.7C3 4.20883 4.20883 3 5.7 3H18.3C19.7912 3 21 4.20883 21 5.7V17.3592L16.5714 13.3735C15.504 12.4128 13.8715 12.4557 12.856 13.4712L12.7051 13.6221C12.3405 13.9867 11.7447 13.971 11.3998 13.5877L9.77138 11.7784C8.80466 10.7043 7.16359 10.5817 6.04807 11.5004L3 14.0106V5.7ZM16.5 10.2C17.4941 10.2 18.3 9.39411 18.3 8.4C18.3 7.40589 17.4941 6.6 16.5 6.6C15.5059 6.6 14.7 7.40589 14.7 8.4C14.7 9.39411 15.5059 10.2 16.5 10.2Z",
    fill: "#181A1B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3673 14.7114L20.7096 19.5194C20.2641 20.3979 19.3524 21 18.3 21H5.7C4.20883 21 3 19.7912 3 18.3V16.3424L7.19235 12.8899C7.56419 12.5836 8.11121 12.6245 8.43345 12.9825L10.0619 14.7919C11.0967 15.9417 12.8841 15.9887 13.9779 14.8949L14.1288 14.744C14.4673 14.4055 15.0115 14.3912 15.3673 14.7114Z",
    fill: "#181A1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.eee63fc8d6aec955163012d093e51749.svg";
export { ForwardRef as ReactComponent };